import React from 'react';
import { motion } from 'framer-motion';
const suns = [{
  emoji: '🎨',
  title: 'La Signature Visuelle',
  domain: 'Le Corps',
  transformation: 'Comment tu te vois dans le miroir'
}, {
  emoji: '🏠',
  title: 'Le Sanctuaire Intérieur',
  domain: "L'Espace & le Temps",
  transformation: 'Comment tu vis ta solitude'
}, {
  emoji: '🤝',
  title: 'La Connexion Sociale',
  domain: 'Ton Cercle',
  transformation: "Qui tu choisis d'avoir autour de toi"
}, {
  emoji: '🧭',
  title: 'Le Futur Architecte',
  domain: 'Ton Identité',
  transformation: 'Qui tu choisis de devenir'
}];
export function MethodSection() {
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-154">
      <div className="max-w-5xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-156">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-charcoal text-center mb-6" data-id="element-157">
            La Méthode RE-NAISSANCE : Le Système des 4 Soleils
          </h2>

          <p className="text-center text-lg mb-8 max-w-3xl mx-auto" data-id="element-158">
            Développée spécifiquement pour les mamans divorcées de France et du
            Québec, cette méthode repose sur 4 piliers que nous appelons les "4
            Soleils" :
          </p>

          <div className="grid md:grid-cols-2 gap-5 mb-8" data-id="element-159">
            {suns.map((sun, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-160">
                <div className="text-4xl mb-3" data-id="element-161">☀️{sun.emoji}</div>
                <h3 className="font-playfair text-2xl text-burgundy mb-2" data-id="element-162">
                  {sun.title}
                </h3>
                <p className="font-semibold text-charcoal mb-2" data-id="element-163">{sun.domain}</p>
                <p className="text-gray-700" data-id="element-164">{sun.transformation}</p>
              </motion.div>)}
          </div>

          <div className="text-center space-y-4 text-lg" data-id="element-165">
            <p className="text-xl font-semibold text-burgundy" data-id="element-166">
              Si l'un de ces soleils est éteint, tu te sens dans le noir.
            </p>
            <p data-id="element-167">Ce système va les rallumer. Tous les quatre. En 30 jours.</p>
            <p data-id="element-168">
              Sans bla-bla. Sans théorie abstraite. Sans exercices qui prennent
              2 heures.
            </p>
            <p className="font-semibold" data-id="element-169">
              Tout est conçu pour des mamans débordées.
            </p>
            <p className="text-gold font-semibold" data-id="element-170">
              Chaque exercice prend entre 5 et 15 minutes maximum.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}